// const main_app_url = 'http://pos.localhost.com:9000';

// const main_app_url = 'https://qrmenu.posist.co';
const main_app_url = process.env.REACT_APP_MAIN_URL;
export const getCustomerInvoice = async (id) => {
    try {
      const response = await fetch(`${main_app_url}/api/eInvoice/getInvoiceTemplate/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch invoice');
      }
  
      return await response.json();
    } catch (error) {
      console.error('Error fetching invoice:', error);
      return null;
    }
  };
  